import { render, staticRenderFns } from "./LeadEdit.vue?vue&type=template&id=0b253236&scoped=true"
import script from "./LeadEdit.vue?vue&type=script&lang=ts"
export * from "./LeadEdit.vue?vue&type=script&lang=ts"
import style0 from "./LeadEdit.vue?vue&type=style&index=0&id=0b253236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b253236",
  null
  
)

export default component.exports